export default __webpack_public_path__ + "static/media/date.a8c57576.svg";